import { createSelector } from 'reselect';
import { selectProductDetailsWrapper } from '../PdpNameSpaceSelector';

export const defaults = {
    base: {},
};

export default createSelector(
    [selectProductDetailsWrapper(false)],
    (productDetails) => productDetails.base || defaults.base
);
